import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IEpDropdownModel } from '@epicor/kinetic';
import { FieldAgentClient, OpportunityStatus, IOpportunityStatus } from 'ep-bt-field-agent-proxy';
import { SearchPageNames } from 'ep-bt-controls';

@Component({
  selector: 'epbt-fa-customer-doc-opp-status-list',
  templateUrl: './epbt-fa-customer-doc-opp-status-list.component.html',
  styleUrls: ['./epbt-fa-customer-doc-opp-status-list.component.scss']
})
export class EpbtFaCustomerDocOppStatusListComponent implements OnInit {

  statusData: any[] = [];
  private _selectedStatus: number;

  @Input('selectedStatus') set selectedStatus(value: number) {
    this._selectedStatus = value;
    if (this._selectedStatus) {
      var result = this.statusData.filter(x => x.opportunityStatusID == this._selectedStatus);
      this.selectedStatusChange.emit(result ? result[0] : null);
    }
  }
  get selectedStatus(): number {
    return this._selectedStatus;
  }

  //@Input() readonly:boolean;
  // selectedTitle: string;
  @Output() selectedStatusChange = new EventEmitter<any>();
  @Input() page: string;
  @Input() isEditable: boolean = true;

  constructor(private client: FieldAgentClient) { }

  ngOnInit() {
    //this.statusData = ['(Not set)', 'Active', 'Lost', 'Won'];
    this.GetstatusData();
  }

  GetstatusData() {
    this.client.getOpportunityStatusList().subscribe(res => {
      this.statusData = res;

      //for filter
      if (this.page == SearchPageNames.CustomerOpportunity || this.page == SearchPageNames.DashboardOpportunitySearch) {
        this.addDefaultStausForFilters();
        var result = this.statusData.filter(x => x.opportunityStatusID == this._selectedStatus);
        this.selectedStatusChange.emit(result && result.length != 0 ? result[0] : this.statusData[0]);
      }
      else {
        this.statusData = res;
      }
      // end filter
    });
  }
  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      this.selectedStatus = selectedValue.opportunityStatusID;
      var result = this.statusData.filter(x => x.opportunityStatusID == this.selectedStatus);
      this.selectedStatusChange.emit(result ? result[0] : null);
    }
  }

  addDefaultStausForFilters() {
    let allOpprtunities = new OpportunityStatus();
    allOpprtunities.opportunityStatusID = -2;
    allOpprtunities.name = 'All Opportunities';

    let activeOpprtunities = new OpportunityStatus();
    activeOpprtunities.opportunityStatusID = -1;
    activeOpprtunities.name = 'Active Opportunities';

    this.statusData.unshift(activeOpprtunities);
    this.statusData.unshift(allOpprtunities);
  }

}
